/*
Copyright (c) 2022 COUNTRYSIDE STOVE & CHIMNEY, INC. - ALL RIGHTS RESERVED

UNAUTHORIZED COPYING, MODIFICATION, OR DISTRIBUTION OF THIS SOFTWARE AND ASSOCIATED DOCUMENTATION FILES ("THE SOFTWARE"),
IN ANY MEDIUM IS STRICTLY PROHIBITED
PROPRIETARY AND CONFIDENTIAL
WRITTEN BY BRANDON SULLIVAN <info@empiredistributing.net>, March 2022
*/

import React, { useState, useLayoutEffect } from 'react'
import { Platform, Pressable } from 'react-native'
import { WebView } from 'react-native-webview';
import {Icon} from 'react-native-elements'

export default function SingleCatalog(props) {
const [payload, setPayload] = useState(false);
const data = props.route.params.data;
const title = props.route.params.title;
const { navigation } = props;
const canGoBack = navigation.canGoBack();


useLayoutEffect(() => {
setPayload(data);
if (!canGoBack) {
navigation.setOptions({
title: title,
headerLeft: () => (
<Pressable
style={{ position: 'absolute', left: 15 }}
onPress={() => {
navigation.navigate("Catalogs")}}>
<Icon
name='home'
type='MaterialCommunityIcons'
color='lightgray'
size={30}
/>
</Pressable>
),
});
}
else {
navigation.setOptions({
title: title
});
}
},[]);



return (
<>
{payload &&
<>
{Platform.OS === 'web' ? (
<iframe src={payload} height={"100%"} width={"100%"} frameBorder={0}/>
) : (
<WebView
source={{uri : payload}}
/>
)}
</>
}
</>
)
}